import Globals from "globals";

// cyAttr is a helper for setting data-cy attributes on components only when in cypress mode.
// Usage: <div {...cyAttr("find-me")} />
export default function cyAttr(attr?: string) {
  return attr !== undefined && Globals.environment === "cypress" ? { "data-cy": attr } : undefined;
}
